import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { ClientConfigurationService } from 'src/app/core/client-configuration/client-configuration.service';
import { ConfigSettings } from 'src/app/core/client-configuration/config-settings.enum';
import { appointmentMenuRoutes, MenuRoute } from 'src/app/core/config/menu-routes';
import { Appointment } from 'src/app/core/models/appointment.model';

@Component({
	selector: 'app-appointment-header',
	templateUrl: './appointment-header.component.html',
	styleUrls: ['./appointment-header.component.scss'],
})
export class AppointmentHeaderComponent implements OnInit, OnDestroy {

	@Input()
	appointment: Appointment;

	@Input()
	pageTitle = '';

	@Input()
	destroyed$: Subject<boolean>;

	routes: MenuRoute[];
	appointmentMenuId = 'appointmentMenu' + `${Math.round(Math.random() * 100)}`;

	constructor(
		public router: Router,
		private menu: MenuController,
		private clientConfig: ClientConfigurationService,
	) { }

	async ngOnInit(): Promise<void> {
		this.routes = [...appointmentMenuRoutes];
		await this.enableFeatures();
		this.destroyed$.subscribe(
			async destroyed => {
				if (destroyed) {
					await this.destroy();
				}
			}
		);
	}

	async ngOnDestroy() {
		await this.destroy();
	}

	private async destroy(): Promise<void> {
		await this.closeMenu();
	}

	async enableFeatures(): Promise<void> {
		if (await this.clientConfig.hasFeature(ConfigSettings.ShowPlantTab)) {
			const linecardRoute = {
				href: 'linecard',
				relative: true,
				text: 'Linecard',
				icon: 'newspaper-outline',
			} as MenuRoute;

			// Place before clear codes
			this.routes.splice(-1, 0, linecardRoute);
		}
	}

	async openMenu(): Promise<void> {
		if (!await this.menu.isOpen(this.appointmentMenuId)) {
			await this.menu.enable(true, this.appointmentMenuId);
			await this.menu.open(this.appointmentMenuId);
		}
	}

	async closeMenu(): Promise<void> {
		if (await this.menu.isOpen(this.appointmentMenuId)) {
			await this.menu.close(this.appointmentMenuId);
		}
	}

	async navigateTo(route: MenuRoute) {
		await this.closeMenu();
		if (!route.relative) {
			this.destroy();
			this.router.navigate([route.href]);
			return;
		}

		this.router.navigate(['appointments', this.appointment.id, route.href]);
	}

}
